import { render, staticRenderFns } from "./popup-dict-detail.vue?vue&type=template&id=14e42d24&scoped=true"
import script from "./popup-dict-detail.vue?vue&type=script&lang=js"
export * from "./popup-dict-detail.vue?vue&type=script&lang=js"
import style0 from "./popup-dict-detail.vue?vue&type=style&index=0&id=14e42d24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e42d24",
  null
  
)

export default component.exports